import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const PageWrapper = styled.div`
  margin: 35px 0 0 60px;
  padding: ${({ theme }) => theme.spacing.ml};
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.pageBackground};

  ${mediaMaxWidth.tablet} {
    margin: 35px 0 0 0;
  }

  ${mediaMaxWidth.phone} {
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const MessageWrapper = styled.div`
  width: 700px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: ${({ theme }) => theme.spacing.sm};

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 40px);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
  }
`;

export const StyledHeader = styled.header`
  ${cardHeaderStyles};
`;

StyledHeader.displayName = "StyledHeader";

export const StyledContent = styled.div`
  ${cardContentStyles};
  display: flex;
  flex-direction: column;
`;

StyledContent.displayName = "StyledContent";

interface ParagraphProps {
  message?: boolean;
}

export const Paragraph = styled.p<ParagraphProps>`
  font-style: ${({ message }) => message && "italic"};
  margin: ${({ theme, message }) =>
    message
      ? `${theme.spacing.ml} ${theme.spacing.none} ${theme.spacing.sm} ${theme.spacing.none}`
      : `${theme.spacing.none}`};
  word-break: break-word;
`;
